// React-Screen CMainPOSInfoMode ("Preisinformationsmodus") - Strangler
// Phase 5, Klasse A/B-Mischung: statische Huelle, aber Texte, die per
// reValue() wechseln. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle mainposinfomode.js (aus
// lib/scripts/pos/components/CMP_CMainPOSInfoMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CMainPOSInfoMode.html, gezogen aus
// tests/visual-baseline/11-overlay-preisinformation.html (dieser Eintrag
// zeigt CMainPOSInfoMode - NICHT CPriceInputMode, wie die Warteschlange
// frueher annahm).
//
// ZWEI MODI, und der zweite ist im Ist-Zustand TOT (nicht reparieren, das
// waere eine GUI-Aenderung): mode == "stock" fuehrt in prepare() ein
// document.getElementById(<okButton>).style.visibility aus, BEVOR der Button
// gezeichnet ist. Das wirft TypeError, CEventDispatcher.eventTrigger
// verschluckt ihn (catch -> unlock), und der Screen erscheint nie. Live
// nachgeprueft: "Inventur & Retourware" -> "Lagerstand-information" tut
// nichts. Der Port behaelt genau diese Zeile an genau dieser Stelle, damit
// das Verhalten gleich bleibt; in der Bridge laeuft prepare() ebenfalls vor
// dem Mounten. Folgefehler davon: BonManager.displayMode wird nie "stock",
// deshalb ist auch showStock() unerreichbar - die Methode bleibt trotzdem,
// weil bonentryops.js sie ueber displayTarget aufrufen wuerde.
//
// reVALUE-FALLE (s. Muster-Abschnitt im Runbook): showPrice/showStock/
// addProduct aendern die Texte per reValue(), das NUR innerHTML schreibt.
// Die class-Attribute bleiben deshalb auf dem Bauzeit-Wert stehen.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// classValue = eingefrorener Bauzeit-Wert (Klasse), value = Zustand (Text).
function Caption({ bridge, path, addclass, classValue, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' +
    (classValue === undefined ? value : classValue);
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style} dangerouslySetInnerHTML={{ __html: value }} />;
}

const XML_EMPTY = ' '; // priceText/unitsText aus LYT_bonOverlay.xml

function MainPOSInfoModeScreen({ bridge }) {
  const t = bridge.t;
  // Legacy: okButton.properties.events.onMousedown = this.addProduct (nur im
  // info-Modus gesetzt; im stock-Modus kommt der Screen nie so weit).
  const okButton = bridge.widget('7', 'CPushButton', {
    events: { onMousedown: () => bridge.addProduct(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });
  // Legacy: backButton.properties.events.onMousedown = this.finish
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: () => bridge.finish(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText - im info-Modus fest, wird nie per reValue geaendert */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={t('LABELS', 'PRICE_INFO_MODE')} />
      {/* contentText - Klasse eingefroren, Text aus dem Zustand */}
      <Caption bridge={bridge} path="4" addclass="contenttext"
               classValue={t('LABELS', 'PRICE_INFO_MODE_TEXT')} value={bridge.state.content} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" classValue={XML_EMPTY} value={bridge.state.price} />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" classValue={XML_EMPTY} value={bridge.state.units} />
      {/* okButton - "Bonieren"; backgroundImage:"" setzte Legacy-prepare mit,
          es landet (leer) nicht im style-Attribut */}
      <div {...okButton} className="CPushButton okbutton"
           style={{ width: '20%', left: '60%', backgroundImage: '' }}>
        <Caption bridge={bridge} path="7:0" addclass="" value={t('BUTTONS', 'ADD_PRODUCT')} />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
    </>
  );
}

export const CMainPOSInfoMode = defineReactScreen({
  className: 'CMainPOSInfoMode',
  addclass: 'CMainPOSInfoMode CashWindow',
  htmlType: 'div',
  Screen: MainPOSInfoModeScreen,
  initialState: { content: null, price: XML_EMPTY, units: XML_EMPTY },
  prepare(bridge) {
    bridge.productId = null;

    // ACHTUNG: unveraendert uebernommen - im stock-Modus wirft diese Zeile
    // (Element noch nicht gezeichnet) und bricht prepare/draw ab. Siehe
    // Kopfkommentar; das ist das Ist-Verhalten, keine Nachlaessigkeit.
    if (bridge.mode == 'stock')
      document.getElementById(bridge.childId('7')).style.visibility = 'hidden';

    bridge.state.content = bridge.t('LABELS', 'PRICE_INFO_MODE_TEXT');

    bridge.Main.BonManager.displayMode = bridge.mode;
    bridge.Main.BonManager.displayTarget = bridge;

    bridge.Main.components.payment.setEnabled(false);
    bridge.Main.components.payment2.setEnabled(false);
    bridge.Main.components.bonfnc.setEnabled(false);
    bridge.Main.components.leftPad.setEnabled(false);

    for (var i = 0; i < bridge.Main.components.bonedit.children.length; i++)
      if (i != 6)
        bridge.Main.components.bonedit.children[i].setEnabled(false);
  },
  methods: {
    // OK-Button: boniert das zuletzt angezeigte Produkt und schliesst.
    addProduct(bridge) {
      if (!bridge.productId)
        return;

      bridge.Main.BonManager.displayMode = 'normal';
      bridge.Main.BonManager.preAddEntryPOS(1, bridge.productId);
      bridge.Main.BonManager.displayMode = 'info';

      bridge.update({ price: bridge.state.price + "<div style='margin-top:35px'>Boniert</div>" });

      bridge.finish();
    },
    // Aufrufer: CBonManager.addProduct ueber displayTarget (info-Modus) und
    // CMainPOS.addProdWithPrice.
    showPrice(bridge, parameters) {
      const prodText = parameters[0];
      const prodPrice = parameters[1];
      const prodUnit = parameters[2];

      bridge.update({
        content: prodText,
        price: prodPrice ? prodPrice + ' &euro;' : '',
        units: prodUnit ? 'pro ' + prodUnit : '',
      });
    },
    // Waere der Aufrufer aus dem stock-Modus - der ist tot (s. oben).
    showStock(bridge, parameters) {
      const prodText = parameters[0];
      const prodStock = parameters[1];
      const prodUnit = parameters[2];

      bridge.update({ content: prodText, price: prodStock + ' ' + prodUnit });
    },
    // Abbrechen-Button.
    finish(bridge) {
      bridge.doFinish('screen');
    },
    // Aufrufer: finish(). Der zweite Aufrufer war der Funkscanner
    // (doFinish("scanner")); er ist am 26.8.2026 entfallen.
    doFinish(bridge, from) {
      bridge.Main.BonManager.displayMode = 'normal';
      bridge.Main.BonManager.displayTarget = null;

      bridge.Main.components.payment.setEnabled(true);
      bridge.Main.components.payment2.setEnabled(true);
      bridge.Main.components.bonfnc.setEnabled(true);
      bridge.Main.components.leftPad.setEnabled(true);
      bridge.Main.components.bonedit.setEnabled(true);

      for (var i = 0; i < bridge.Main.components.bonedit.children.length; i++)
        bridge.Main.components.bonedit.children[i].setEnabled(true);


      log.add(4, 'Info', 'Price-information mode off', '');

      bridge.removeMe();
    },
  },
});
